import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Music, Pause, Play } from "lucide-react";
import api, { API } from "@/lib/api";

const KEY = "lux_soundtrack";

export default function SoundtrackPlayer({ visible }) {
  const [available, setAvailable] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => { api.get("/soundtrack/info").then((r) => setAvailable(r.data.available)).catch(() => {}); }, []);

  useEffect(() => {
    const a = audioRef.current;
    if (!a || !available) return;
    if (!visible) { a.pause(); setPlaying(false); return; }
    if (localStorage.getItem(KEY) === "on") {
      a.play().then(() => setPlaying(true)).catch(() => setBlocked(true));
    }
  }, [visible, available]);

  const toggle = async () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) { a.pause(); setPlaying(false); localStorage.setItem(KEY, "off"); return; }
    try { await a.play(); setPlaying(true); setBlocked(false); localStorage.setItem(KEY, "on"); } catch (_) { setBlocked(true); }
  };

  if (!available) return null;
  return (
    <>
      <audio ref={audioRef} src={`${API}/soundtrack`} loop preload="none" />
      <AnimatePresence>
        {visible && (
          <motion.button initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 20 }} transition={{ duration: 0.4 }}
            onClick={toggle} data-testid="soundtrack-toggle" aria-label={playing ? "Metti in pausa la colonna sonora" : "Ascolta la colonna sonora"}
            className="fixed bottom-24 right-6 z-[115] glass rounded-full pl-3 pr-4 py-2 flex items-center gap-3 text-[#2A1F14] shadow-lg hover:border-gold/60 transition-colors">
            <span className="relative w-8 h-8 rounded-full bg-gold text-black flex items-center justify-center">
              {playing ? <Pause size={14} /> : <Play size={14} className="ml-0.5" />}
              {playing && <span className="absolute inset-0 rounded-full border border-gold animate-ping opacity-50" />}
            </span>
            <span className="text-left leading-tight">
              <span className="block text-[10px] uppercase tracking-[0.2em] text-gold">Colonna sonora</span>
              <span className="block text-xs text-[#2A1F14]/75 inline-flex items-center gap-1"><Music size={11} /> {playing ? "Lux Aeterna · in ascolto" : blocked ? "Tocca per ascoltare" : "Lux Aeterna"}</span>
            </span>
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
}
